import { apiRegister } from '../../common/api'
import {
  array2map,
  text2time,
  isArray,
  isPlain,
  isNumber,
  map,
  forIn,
  forEach
} from '../../utils/base'
import { ERR_REQ_CID, ERR_REP_CONFIG } from '../../const'
import { KUser } from '../../models/k-user'
// import { NO_ERROR } from '../../const'

/*
协议Id 
877
项目 
模块 
方式 
https 
命令（路径） 
/award/match/config/
说明
获取斗K比赛配置详情
*/

// 1040	award/match	/award/match/configs/	根据cids获取配置
export const matchConfigs = apiRegister('matchConfigs', {
  protoId: 1040,
  path: '/award/match/configs/',
  cache: 600, // 默认缓存600秒
  checkQuery(Q) {
    if (!Q.cIds) {
      return ERR_REQ_CID // 参数错误
    }
    return 0
  },
  checkResult(R) {
    const { configList } = R
    if (!isArray(configList)) {
      return ERR_REP_CONFIG // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    function formatConfig(configInfo) {
      const { blockList, cupList } = configInfo
      const blockMap = array2map(blockList, 'name')
      const cupMap = array2map(cupList, 'cupId')

      // 时间转化
      const {
        id,
        hasFinal,
        signBeginTime,
        signEndTime,
        preBeginTime,
        preEndTime,
        preResTime,
        finalBeginTime,
        finalEndTime,
        finalResTime,
        awardTime,
        addressEndTime
      } = configInfo

      return {
        hasFinal,
        id,
        blockList,
        // configInfo,
        cupList,
        blockMap,
        cupMap,
        signBegin: text2time(signBeginTime),
        signEnd: text2time(signEndTime),
        preBegin: text2time(preBeginTime),
        preEnd: text2time(preEndTime),
        preRes: text2time(preResTime),
        finalBegin: text2time(finalBeginTime),
        finalEnd: text2time(finalEndTime),
        finalRes: text2time(finalResTime),
        awardTime: text2time(awardTime),
        addressEnd: text2time(addressEndTime)
      }
    }

    const { configList } = R
    console.log(configList.length)
    const configMap = {}
    forEach(configList, Conf => {
      const cId = Conf.id
      configMap[cId] = formatConfig(Conf)
    })
    return {
      configMap
    }
  }
}).send

/*
协议Id 
877
项目 
模块 
方式 
https 
命令（路径） 
/award/match/config/
说明
获取斗K比赛配置详情
*/

// 1009	xsh/config	/xsh/config/moduledata/	模块级数据
// export const matchConfig = apiRegister('matchConfig', {
//   protoId: 877,
//   path: '/award/match/config/',
//   cache: 600, // 默认缓存600秒
//   checkQuery(Q) {
//     if (!isNumber(Q.cId)) {
//       return ERR_REQ_CID // 参数错误
//     }
//     return 0
//   },
//   checkResult(R) {
//     const { configInfo, blockList, cupList } = R
//     if (!isPlain(configInfo) || !isArray(blockList) || !isArray(cupList)) {
//       return ERR_REP_CONFIG // 数据格式非法
//     }
//     return 0
//   },
//   formatResult(R) {
//     const { blockList, configInfo, cupList } = R
//     const blockMap = array2map(blockList, 'name')
//     const cupMap = array2map(cupList, 'cupId')

//     // 时间转化
//     const {
//       signBeginTime,
//       signEndTime,
//       preBeginTime,
//       preEndTime,
//       preResTime,
//       finalBeginTime,
//       finalEndTime,
//       finalResTime,
//       awardTime,
//       addressEndTime
//     } = configInfo

//     return {
//       blockList,
//       configInfo,
//       cupList,
//       blockMap,
//       cupMap,
//       timeMap: {
//         signBegin: text2time(signBeginTime),
//         signEnd: text2time(signEndTime),
//         preBegin: text2time(preBeginTime),
//         preEnd: text2time(preEndTime),
//         preRes: text2time(preResTime),
//         finalBegin: text2time(finalBeginTime),
//         finalEnd: text2time(finalEndTime),
//         finalRes: text2time(finalResTime),
//         awardTime: text2time(awardTime),
//         addressEnd: text2time(addressEndTime)
//       }
//     }
//   }
// }).send

/*
1038	award/match	/award/match/rewarduserlist/	用户奖励榜单
参数名称	参数类型	说明
cId	int	比赛配置id
*/
export const matchWinnersLuckyLoad = apiRegister('matchWinnersLucky', {
  protoId: 1038,
  path: '/award/match/rewarduserlist/',
  checkQuery(Q) {
    if (!isNumber(Q.cId)) {
      return ERR_REQ_CID // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    const { userInfos, myInfo } = R
    let { data } = R
    const list = []
    const userMap = array2map(userInfos, 'uid')
    forIn(data, u => {
      const user = KUser(userMap[u.uid])
      u.nick = user.nick
      u.logoSrc = user.logoSrc
      list.push(u)
    })

    console.log(list)
    console.log(userMap)
    return {
      data,
      list,
      userMap,
      myInfo
    }
  }
}).send

/*
1039	award/match	/award/match/randrewardlist/	随机奖励用户列表
参数名称	参数类型	说明
cId	int	比赛配置id
*/
export const matchWinnersRandomLoad = apiRegister('matchWinnersRandom', {
  protoId: 1039,
  path: '/award/match/randrewardlist/',
  checkQuery(Q) {
    if (!isNumber(Q.cId)) {
      return ERR_REQ_CID // 数据格式非法
    }
    return 0
  },
  formatResult(R) {
    const { userInfos, myInfo } = R
    let { list } = R
    const userMap = array2map(userInfos, 'uid')
    forEach(list, u => {
      const user = KUser(userMap[u.uid])
      u.nick = user.nick
      u.logoSrc = user.logoSrc
    })

    // console.log(list)
    return {
      list,
      userMap,
      myInfo
    }
  }
}).send
